import Alpine from 'alpinejs'
import header from './components/header.js'
import concepts from './components/concepts.js'
import reviews from './components/reviews.js'
import slider from './components/slider.js'
import tabs from './components/tabs.js'
import flow from './components/flow.js'
import calendly from './components/calendly.js'

Alpine.data('header', header)
Alpine.data('concepts', concepts)
Alpine.data('reviews', reviews)
Alpine.data('slider', slider)
Alpine.data('tabs', tabs)
Alpine.data('flow', flow)
Alpine.data('calendly', calendly)

Alpine.start()

checkFaders();
window.addEventListener('scroll', checkFaders);

function checkFaders() {
  var faders = document.querySelectorAll('.fade:not(.faded)');
  
  if (!faders.length) {
    window.removeEventListener('scroll', checkFaders);
    return;
  }

  faders.forEach((el) => {
    if (inScreen(el, .8)) {
      el.classList.add('faded');
    }
  });
}

function inScreen(el, k) {
  let box = el.getBoundingClientRect();

  return window.innerHeight * k > box.top;
}
